var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"exception"},[_c('img',{attrs:{"src":require("./404.png")}}),_c('div',{staticClass:"text"},[_vm._v("页面不见了")])])}]

export { render, staticRenderFns }